import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Feature } from '@/pinia/feature'
import { useFeature } from '@/pinia/features'
import { computed, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'

type Props = {
  feature: string | Feature
  filter?: (feature: Feature) => boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FeatureChildren',
  props: {
    feature: {},
    filter: { type: Function }
  },
  setup(__props: any) {

const props = __props
const { feature: featureName } = toRefs(props)

const { locale } = useI18n()

const { feature: featureP } = useFeature(
  typeof featureName.value === 'string' ? featureName.value : undefined
)

const featureParent = computed(
  () => featureP.value ?? (typeof featureName.value !== 'string' ? featureName.value : undefined)
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featureParent.value?.children, (feat) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: feat.name
    }, [
      (feat?.component && feat?.enabled && (!_ctx.filter || _ctx.filter(feat)))
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(feat?.component), _mergeProps({
            key: 0,
            title: feat?.title[_unref(locale)],
            info: feat?.info?.[_unref(locale)],
            feature: feat,
            featureName: feat?.name
          }, { ref_for: true }, { ..._ctx.$attrs, ...(feat.props ?? {}) }), null, 16, ["title", "info", "feature", "featureName"]))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}
}

})